module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-5.9881b6bf.jpg";